import ActionSheet, { ACTION_SHEET_TRANSITION_DURATION } from './ActionSheet';
import { showWithTransition } from '../../utils/show';
import { wrapWithConfigDefaults } from '../../utils/helper';
export default wrapWithConfigDefaults(function (config) {
    config.onClickMask = config.onClickMask || config.onCancel;
    return showWithTransition({
        Component: ActionSheet,
        transitionDuration: ACTION_SHEET_TRANSITION_DURATION,
        autoClose: false,
        props: config,
        injectClosePropNames: [
            'onCancel',
            'onClickAction',
            'onClickHeaderAction',
            'onClickPrimaryAction',
            'onClickSecondaryAction',
            'onClickMask',
        ],
        contexts: config.contexts,
    });
});
